import { gql } from "@apollo/client";

export const GET_TIPO_INSTITUCIONES = gql`
query QTipoInstituciones {
    tipoInstituciones
        {
            success,
            error,
            valorEsperado {
                id,
                descripcion
            }
        }
}`;